"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineUpdateDate = void 0;
function defineUpdateDate(entity) {
    if (entity.createdAt && !entity.updatedAt) {
        return entity.createdAt;
    }
    if (entity.createdAt && entity.updatedAt) {
        return entity.updatedAt;
    }
    return "-";
}
exports.defineUpdateDate = defineUpdateDate;
